/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminUserActivityDto
 */
export interface AdminUserActivityDto {
    /**
     * Number of users active in last 7 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    activeUsers7d: number;
    /**
     * Number of users active in last 30 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    activeUsers30d: number;
    /**
     * Number of users active in last 90 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    activeUsers90d: number;
    /**
     * Number of users inactive for more than 30 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    inactiveUsers30d: number;
    /**
     * Number of users inactive for more than 90 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    inactiveUsers90d: number;
    /**
     * Number of users inactive for more than 180 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    inactiveUsers180d: number;
    /**
     * Number of users registered in last 7 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    registrations7d: number;
    /**
     * Number of users registered in last 30 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    registrations30d: number;
    /**
     * Number of users registered in last 90 days
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    registrations90d: number;
    /**
     * Daily Active Users (users logged in last 24 hours)
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    dau: number;
    /**
     * DAU/MAU ratio as percentage (engagement index)
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    dauMauRatio: number;
    /**
     * Average sessions per month (MAU/totalUsers * 30 approximation)
     * @type {number}
     * @memberof AdminUserActivityDto
     */
    averageSessionsPerMonth: number;
}

export function AdminUserActivityDtoFromJSON(json: any): AdminUserActivityDto {
    return AdminUserActivityDtoFromJSONTyped(json, false);
}

export function AdminUserActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUserActivityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activeUsers7d': json['activeUsers7d'],
        'activeUsers30d': json['activeUsers30d'],
        'activeUsers90d': json['activeUsers90d'],
        'inactiveUsers30d': json['inactiveUsers30d'],
        'inactiveUsers90d': json['inactiveUsers90d'],
        'inactiveUsers180d': json['inactiveUsers180d'],
        'registrations7d': json['registrations7d'],
        'registrations30d': json['registrations30d'],
        'registrations90d': json['registrations90d'],
        'dau': json['dau'],
        'dauMauRatio': json['dauMauRatio'],
        'averageSessionsPerMonth': json['averageSessionsPerMonth'],
    };
}

export function AdminUserActivityDtoToJSON(value?: AdminUserActivityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activeUsers7d': value.activeUsers7d,
        'activeUsers30d': value.activeUsers30d,
        'activeUsers90d': value.activeUsers90d,
        'inactiveUsers30d': value.inactiveUsers30d,
        'inactiveUsers90d': value.inactiveUsers90d,
        'inactiveUsers180d': value.inactiveUsers180d,
        'registrations7d': value.registrations7d,
        'registrations30d': value.registrations30d,
        'registrations90d': value.registrations90d,
        'dau': value.dau,
        'dauMauRatio': value.dauMauRatio,
        'averageSessionsPerMonth': value.averageSessionsPerMonth,
    };
}

